import React from "react";
import styled from "styled-components";
import { Cross } from "../../../assets/images/Cross";
import { COLORS } from "../../../assets/constants/styles";

export const InputField = ({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  errormessage,
  required,
  type = "text",
}) => {
  const handleClear = () => {
    if (onChange) onChange("");
  };

  return (
    <InputContainer>
      {label && <Label>{label}</Label>}
      <InputWrapper $errormessage={errormessage} disabled={disabled}>
        <StyledInput
          required={required}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          disabled={disabled}
        />
        <ClearButtonContainer
          type="button"
          onClick={handleClear}
          disabled={disabled || !value}
        >
          <Cross />
        </ClearButtonContainer>
      </InputWrapper>
      {errormessage && <ErrorMessage>{errormessage}</ErrorMessage>}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem; /* 10px */
  margin: 1.5rem 0;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.875rem; /* 14px */
  font-weight: 500;
  line-height: 1.3125rem; /* 21px */
  color: ${COLORS.black};
`;

const InputWrapper = styled.div`
  min-height: 1.313rem;
  display: flex;
  align-items: center;
  border: 1px solid
    ${(props) => (props.$errormessage ? COLORS.red : COLORS.lightViolet)};
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  background: ${(props) => (props.disabled ? COLORS.lightGrey : COLORS.white)};
  color: ${(props) => (props.disabled ? COLORS.white : COLORS.black)};

  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.4s;

  &:active,
  &:hover {
    border: 1px solid ${COLORS.lightViolet};
  }
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 0.875rem;
  min-height: 1.375rem;
  padding: 0;

  &:disabled {
    background: none;
    color: ${COLORS.lightGrey};
  }
`;

const ClearButtonContainer = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${COLORS.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${COLORS.grey};
  }

  &:disabled {
    display: none;
  }
`;

const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: ${COLORS.red};
`;
